export const CALENDAR_REGISTERED = 'calendar:registered';
export const CALENDAR_UNREGISTERED = 'calendar:unregistered';
export const CALENDAR_UPDATED = 'calendar:update';
export const CALENDAR_DELETE = 'calendar:delete';
export const CALENDAR_CREATE = 'calendar:create';
export const CALENDAR = 'CALENDAR';
